module.exports = __webpack_public_path__ + "img/download-icon.df44d88f.svg";